<template>
  <MainLayout/>
</template>

<script>
import MainLayout from '@/components/base/MainLayout'
import { defineComponent } from "vue";

export default defineComponent({
  name: 'App',
  components: {
    MainLayout,
  },
  setup() {

    return {

    }
  }
});
</script>

<style>

</style>